// extracted by mini-css-extract-plugin
export default {"container":"OrderThumbnail_container__Mp6I5","small":"OrderThumbnail_small__H8HVm","tag":"OrderThumbnail_tag__SkbYW"};